<template>
  <div class="toggle-switch" :class="{ checked: modelValue }" @click="toggle"></div>
</template>

<script src="./ToggleSwitch.js"></script>
